import { render, staticRenderFns } from "./PhotoLibraryViewer.vue?vue&type=template&id=ef846d52&"
import script from "./PhotoLibraryViewer.vue?vue&type=script&lang=js&"
export * from "./PhotoLibraryViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports